var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
const SvgVerticalIcon = props => /*#__PURE__*/React.createElement("svg", _extends({
  xmlns: "http://www.w3.org/2000/svg",
  width: 12,
  height: 16,
  fill: "none"
}, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
  fill: "#333",
  d: "M9.445 12.566V7.094c0-.5-.413-.91-.918-.91a.917.917 0 0 0-.917.91v5.472H5.967c-.413 0-.615.491-.321.773l2.56 2.531a.474.474 0 0 0 .652 0l2.56-2.53c.294-.283.083-.774-.32-.774zM2.7.13.14 2.67c-.295.282-.093.774.32.774h1.643v5.47c0 .502.413.911.918.911s.918-.41.918-.91V3.444H5.58c.413 0 .615-.492.322-.774L3.343.13a.463.463 0 0 0-.643 0"
})));
export { SvgVerticalIcon as ReactComponent };
export default __webpack_public_path__ + "1c77c368cf01c1283a5eb17e546eb032.svg";